// Per-draft id map: stable catalog clip ids -> device-local freecut media ids.
// Populated by hydrate (and by Catalog-add / Replace-with when they import a new
// clip), and reversed by flushDraft before the PUT so the server's project.json
// always stores stable catalog ids in `mediaId`. Without this, autosave forwards
// freecut's locally-minted media ids back to the server and the next hydrate
// (any device, including this one after OPFS clear) 404s on /clips/<freecutId>.

const KEY = (draftId: string): string => `smm:idmap:${draftId}`

export function getIdMap(draftId: string): Record<string, string> {
  const raw = localStorage.getItem(KEY(draftId))
  if (!raw) return {}
  try {
    return JSON.parse(raw) as Record<string, string>
  } catch {
    return {}
  }
}

export function setIdMapEntry(draftId: string, catalogId: string, freecutMediaId: string): void {
  const m = getIdMap(draftId)
  m[catalogId] = freecutMediaId
  localStorage.setItem(KEY(draftId), JSON.stringify(m))
}

export function clearIdMap(draftId: string): void {
  localStorage.removeItem(KEY(draftId))
}
